import { render } from "./InstituteImport.vue?vue&type=template&id=04d05ffc"
import script from "./InstituteImport.vue?vue&type=script&lang=js"
export * from "./InstituteImport.vue?vue&type=script&lang=js"

import "./InstituteImport.vue?vue&type=style&index=0&id=04d05ffc&lang=scss"
script.render = render

export default script